import { TrendingUp, TrendingDown } from "lucide-react";

export function Delta({ current, previous, title = "rispetto al periodo precedente" }) {
  if (current == null || previous == null) return null;
  if (previous === 0) {
    if (!current) return null;
    return (
      <span className="text-[11px] font-medium text-muted-foreground" title={title}>
        nuovo
      </span>
    );
  }
  const pct = ((current - previous) / Math.abs(previous)) * 100;
  const up = pct >= 0;
  const Icon = up ? TrendingUp : TrendingDown;
  return (
    <span
      title={title}
      data-testid="delta-badge"
      className={`inline-flex items-center gap-0.5 text-[11px] font-semibold ${up ? "text-emerald-400" : "text-rose-400"}`}
    >
      <Icon className="h-3 w-3" />
      {up ? "+" : ""}{pct.toFixed(1)}%
    </span>
  );
}
